import { render, staticRenderFns } from "./FarmingStageRow.vue?vue&type=template&id=07fbd520&"
import script from "./FarmingStageRow.vue?vue&type=script&lang=js&"
export * from "./FarmingStageRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports